import React from 'react'
import { Link } from 'react-router-dom'
import './footer.css'

const Footer = ({ activePage = '' }) => {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <main className="footer-main-content">
          <div className="footer-content-inner">
            <header className="footer-main">
              <div className="footer-header">
                <img
                  alt="Social Recruiting Agentur Berlin"
                  src="/social-media-recruiting-agentur-logo-weiss.png"
                  className="footer-branding"
                />
                <span className="footer-description">
                  Ihre spezialisierte Social Media Recruiting Agentur aus Berlin für professionelles Social Media Recruiting. Wir helfen Unternehmen beim Einstieg in die digitale Mitarbeitergewinnung.
                </span>
              </div>
              <div className="footer-badges">
                <a href="https://www.bvmw.de" target="_blank" rel="noreferrer noopener" title="BVMW Mitglied">
                  <img
                    alt="BVMW Mitglied"
                    src="/bvmw-ev-mittelstand-bundesverband-loco.webp"
                    className="footer-badge"
                  />
                </a>
                <a href="https://grow.google/intl/de/google-ai-essentials/" target="_blank" rel="noreferrer noopener" title="Google AI Essentials">
                  <img
                    alt="Google AI Essentials"
                    src="/google-ai-essentials-logo.webp"
                    className="footer-badge"
                  />
                </a>
                <a href="https://www.bescheinigung-forschungszulage.de" target="_blank" rel="noreferrer noopener" title="BSFZ Siegel">
                  <img
                    alt="BSFZ Siegel"
                    src="/bsfz-siegel-rgb.svg"
                    className="footer-badge"
                  />
                </a>
              </div>
              <div className="footer-socials">
                <a
                  href="https://de.linkedin.com/company/famefact/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-social-link"
                >
                  <img
                    alt="LinkedIn"
                    src="/Icons/linkedin-200h.png"
                    className="social"
                  />
                </a>
                <a
                  href="https://www.instagram.com/famefact/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-social-link"
                >
                  <img
                    alt="Instagram"
                    src="/Icons/instagram-200h.png"
                    className="social"
                  />
                </a>
                <a
                  href="https://x.com/famefact/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-social-link"
                >
                  <svg
                    className="social x-icon"
                    viewBox="0 0 24 24"
                    fill="white"
                    style={{ width: '24px', height: '24px' }}
                    aria-label="X (Twitter)"
                  >
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                  </svg>
                </a>
              </div>
            </header>
            <header className="footer-categories">
              <div className="footer-category">
                <div className="footer-category-header">
                  <span className="footer-header-text">Services</span>
                </div>
                <div className="footer-links">
                  <Link 
                    to="/social-recruiting-beratung" 
                    className={`footer-link ${activePage === 'social-recruiting-beratung' ? 'active' : ''}`}
                  >
                    Social Recruiting Beratung
                  </Link>
                  <Link 
                    to="/social-media-recruiting-kampagnen" 
                    className={`footer-link ${activePage === 'social-media-recruiting-kampagnen' ? 'active' : ''}`}
                  >
                    Social Media Recruiting Kampagnen
                  </Link>
                  <Link 
                    to="/employer-branding" 
                    className={`footer-link ${activePage === 'employer-branding' ? 'active' : ''}`}
                  >
                    Employer Branding
                  </Link>
                  <Link 
                    to="/active-sourcing" 
                    className={`footer-link ${activePage === 'active-sourcing' ? 'active' : ''}`}
                  >
                    Active Sourcing
                  </Link>
                  <Link 
                    to="/recruiting-ads-management" 
                    className={`footer-link ${activePage === 'recruiting-ads-management' ? 'active' : ''}`}
                  >
                    Recruiting Ads Management
                  </Link>
                </div>
              </div>
              <div className="footer-category">
                <div className="footer-category-header">
                  <span className="footer-header-text">Unternehmen</span>
                </div>
                <div className="footer-links">
                  <Link
                    to="/"
                    className={`footer-link ${activePage === 'home' ? 'active' : ''}`}
                  >
                    Home
                  </Link>
                  <Link
                    to="/ueber-uns"
                    className={`footer-link ${activePage === 'ueber-uns' ? 'active' : ''}`}
                  >
                    Über uns
                  </Link>
                  <Link
                    to="/cases"
                    className={`footer-link ${activePage === 'cases' ? 'active' : ''}`}
                  >
                    Cases
                  </Link>
                  <a
                    href="/blog.html"
                    className="footer-link"
                  >
                    Blog
                  </a>
                </div>
              </div>
              <div className="footer-category">
                <div className="footer-category-header">
                  <span className="footer-header-text">Ressourcen</span>
                </div>
                <div className="footer-links">
                  <a
                    href="/lexikon/"
                    className="footer-link"
                  >
                    Lexikon
                  </a>
                  <a
                    href="/branchen/"
                    className="footer-link"
                  >
                    Branchen
                  </a>
                  <a
                    href="/social-media-recruiting/"
                    className="footer-link"
                  >
                    Standorte
                  </a>
                </div>
              </div>
              <div className="footer-category">
                <div className="footer-category-header">
                  <span className="footer-header-text">Rechtliches</span>
                </div>
                <div className="footer-links">
                  <Link
                    to="/impressum"
                    className={`footer-link ${activePage === 'impressum' ? 'active' : ''}`}
                  >
                    Impressum
                  </Link>
                  <Link
                    to="/datenschutz"
                    className={`footer-link ${activePage === 'datenschutz' ? 'active' : ''}`}
                  >
                    Datenschutz
                  </Link>
                  <Link
                    to="/agb"
                    className={`footer-link ${activePage === 'agb' ? 'active' : ''}`}
                  >
                    AGB
                  </Link>
                  <Link
                    to="/disclaimer"
                    className={`footer-link ${activePage === 'disclaimer' ? 'active' : ''}`}
                  >
                    Disclaimer
                  </Link>
                </div>
              </div>
            </header>
          </div>
          <section className="footer-copyright">
            <span className="footer-copyright-text">
              © 2025 Social Media Recruiting Agentur - track by track GmbH. Alle Rechte vorbehalten.
            </span>
          </section>
        </main>
      </div>
    </footer>
  )
}

export default Footer
